'use strict';

import axios from 'axios';
// import qs from 'qs'
import mybase from './base64.js';

import api from './type.js';
import {
	isJson
} from './method.js'

// axios 配置
axios.defaults.timeout = 600000; //设置超时时间
axios.defaults.baseURL = 'https://api.haojun.work/api/Data'; //这是调用数据接口 测试 热点
// axios.defaults.baseURL = 'http://api.haojun.work/my_mode.asmx'; //润恒网站接口

// https://image.sxrhkjweb.top:8898/

// 添加请求拦截器
axios.interceptors.request.use(
	(config) => {
		// loading
		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);
// 添加响应拦截器
axios.interceptors.response.use(
	(response) => {
		return response;
	},
	(error) => {
		return Promise.resolve(error.response);
	}
);

function checkStatus(response) {
	// loading
	// 如果http状态码正常，则直接返回数据
	if (response && (response.status === 200 || response.status === 304 || response.status === 400)) {
		return response.data;
		// 如果不需要除了data之外的数据，可以直接 return response.data
	}
	// 异常状态下，把错误信息返回去
	return {
		status: -404,
		msg: '网络异常'
	};
}

function checkCode(res) {
	// 如果code异常(这里已经包括网络错误，服务器错误，后端抛出的错误)，可以弹出一个错误提示，告诉用户
	if (res.status === -404) {
		alert(res.msg);
	}
	if (res.data && !res.data.success) {
		alert(res.data.error_msg);
	}
	return res;
}

export default {

	post(url, param1) {
		// 构建请求数据
		const requestData = {
			token: api.http_token,
			data: mybase.base_encode(param1)
		};
	
		// console.log('发送的数据:', JSON.stringify(requestData));
	
		return axios({
				method: 'post',
				url,
				data: requestData,
				headers: {
					'X-Requested-With': 'XMLHttpRequest',
					'Content-Type': 'application/x-www-form-urlencoded'
				},
				timeout: 30000 // 设置30秒超时
			})
			.then((response) => {
				var res = checkStatus(response);
				// console.log('处理后结果:', res);
	
				var backdata;
	
				if (res && res.statue === "1") {
					// 如果result存在，进行解码
					// console.log('接收数据库返回:', res.result);
					var js=JSON.parse(res.result)
					// console.log('JSON转换:', js);
					if (js.status==="1" && js.result) {
						try {
							backdata = mybase.decode(mybase.decode(js.result));
							backdata = backdata.replace(/[\r\n]/g, "");
							// console.log("解码成功:", backdata);
						} catch (error) {
							console.error("解码失败:", error);
							backdata = {
								data: {
									statue: "0",
									msg: "解码失败: " + error.message
								}
							};
						}
					} else {
						backdata = {
							data: {
								statue: "0",
								msg: "响应中没有result字段"
							}
						};
					}
				} else {
					// 错误处理
					// console.log("请求失败:", res);
					if (res && res.result) {
						try {
							backdata = mybase.decode(mybase.decode(res.result));
							backdata = backdata.replace(/[\r\n]/g, "");
						} catch (e) {
							backdata = JSON.stringify(res);
						}
					} else {
						backdata = {
							data: {
								statue: "0",
								msg: res.message || "请求失败"
							}
						};
					}
				}
	
				return backdata;
			})
			.catch((error) => {
				console.error('请求异常:', error);
	
				return {
					data: {
						statue: "0",
						msg: error.message || "网络错误"
					}
				};
			});
	},
	postfile(url, param1, callback1, callback2) {
		// console.log("POST \n" + url + "\n" + param1 + "\n" + "param2");
		var Content_type = '';
		// switch (BrowserGet()) {
		// 	case 'firefox':
		// 		Content_type = 'application/x-www-form-urlencoded;';
		// 		break;
		// 	default:
		// 		Content_type = 'application/x-www-form-urlencoded;';
		// 		break;
		// }

		Content_type = 'application/x-www-form-urlencoded;';

		// 用来传文件
		return axios({
				method: 'post',
				url,
				data: 'token=' + api.http_token + '&data=' + mybase.base_encode(param1),
				headers: {
					'X-Requested-With': 'XMLHttpRequest',
					'Content-Type': Content_type
				},
				onUploadProgress: function(e) {
					//原生获取上传进度的事件
					if (e.lengthComputable) {
						//属性lengthComputable主要表明总共需要完成的工作量和已经完成的工作是否可以被测量
						//如果lengthComputable为false，就获取不到progressEvent.total和progressEvent.loaded
						// console.log(e.loaded);
						callback1(e);
					}
				}
				// ,
				// onDownloadProgress: function(e) {
				//   if (e.lengthComputable) {
				//     //属性lengthComputable主要表明总共需要完成的工作量和已经完成的工作是否可以被测量
				//     //如果lengthComputable为false，就获取不到progressEvent.total和progressEvent.loaded
				//     // console.log(e.loaded);
				//     callback2(e);
				//   }
				// }
			})
			.then((response) => {
				var res = checkStatus(response);
				// 这种方法偶尔因为乱码的问题报错
				// console.log(res);
				// res = res.match(".*?({.*}).*", "");
				// var backdata = JSON.parse(res[1]);
				// if (typeof res === String) {
				// 	res = JSON.parse(res);
				// }
				// console.log(res);

				var backdata;

				if (String(res).length > 0 && res.status == '1') {
					// res = res.match(".*?({.*}).*", "");
					// console.log(res);
					backdata = mybase.decode(mybase.decode(res.result));
					// 去掉隐藏的换行符。 2019-11-08
					backdata = backdata.replace(/[\r\n]/g, "");
					// console.log(backdata);
				} else {
					backdata = '{"data":' + JSON.stringify(res) + "}";
					// console.log(backdata);
				}

				return backdata;
			})
			.then((res) => {
				// console.log('errrrrrrrrrrr');
				// console.log(res);
				return checkCode(res);
			});
	},
	postFormData(url, fileData, fData) {
		// console.log('POST= \n'+url+'\n parm1='+param1+'\n token='+api.http_token);

		return axios({
				method: 'post',
				url,
				filePath: fileData,
				name: 'file',
				formData: fData,
				headers: {
					'X-Requested-With': 'XMLHttpRequest',
					'Content-Type': 'application/x-www-form-urlencoded;'
				}
			})
			.then((response) => {
				// console.log('=========11111');
				var res = checkStatus(response);
				// 这种方法偶尔因为乱码的问题报错
				// console.log(res);
				var backdata;
				if (String(res).length > 0 && res.status == '1') {
					// res = res.match(".*?({.*}).*", "");
					// console.log(res);
					backdata = mybase.decode(mybase.decode(res.result));
					// 去掉隐藏的换行符。 2019-11-08
					backdata = backdata.replace(/[\r\n]/g, "");
					// backdata = JSON.parse(backdata);
					// console.log(backdata);
					// if (!isJson(backdata)) {
					//   backdata = {
					//     "data": {
					//       "status": "1",
					//       "msg": "返回数据格式不正确,请检查 \r\n " + JSON.stringify(res)
					//     }
					//   };
					// }
				} else {
					backdata = '{"data":' + JSON.stringify(res) + "}";

				}
				// console.log(backdata);
				return backdata;



			})
			.then((res) => {
				// console.log('=========2');
				return checkCode(res);
			});
	},
	get(url, param1, param2) {
		console.log('Get \n' + url + '\n' + param1 + '\n' + param2);
		return axios({
				method: 'get',
				url: url + '?method=' + param1 + '&data=' + mybase.encode(param2),
				headers: {
					'X-Requested-With': 'XMLHttpRequest'
				}
			})
			.then((response) => {
				var res = checkStatus(response);
				// res = res.match(".*?({.*}).*", "");
				//console.log(res[1]);
				// var backdata = JSON.parse(res[1]);

				return mybase.decode(res.result);
			})
			.then((res) => {
				return checkCode(res);
			});
	}
};
